/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const LengthUnit = {
    In: 'IN',
    Cm: 'CM'
} as const;
export type LengthUnit = typeof LengthUnit[keyof typeof LengthUnit];

